module.exports = __webpack_public_path__ + "img/diamond.b65e5db8.png";